import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.jsx";

const root = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The build pre-renders the page into #root; hydrate it. Plain `vite dev` serves an empty root, so render.
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
